import React from 'react'
import PlanCard from '../PlanCard'

type Props = {
  price: string
  total: string
  loading: boolean
  Pagar: ({ months, price, total, type }: any) => void
}

export const PaymentMonthly = ({ price, total, loading, Pagar }: Props) => {
  return (
    <>
      <PlanCard
        title="Padrão"
        price={price}
        cents={price}
        caption="Pagamento mensal"
        description={['Forma de pagamento único']}
        value={`O valor de R$ ${price.replace('.', ',')}`}
        cardColor="#3EB9F2"
        buttonText={
          <div className="w-full h-full">
            {loading ? (
              <div className="flex justify-center w-full h-full">
                <button
                  style={{ color: '#3EB9F2' }}
                  className="w-5/6 py-2 mt-2 font-semibold text-center bg-white rounded"
                >
                  Aguarde...
                </button>
              </div>
            ) : (
              <div className="flex justify-center w-full h-full  ">
                <button
                  style={{ color: '#3EB9F2' }}
                  id="checkout-btn2"
                  onClick={() =>
                    Pagar({
                      months: '1',
                      price: price,
                      total: total,
                      type: 'Pagamento de um mês acesso ao site igreja nas nuvens',
                    })
                  }
                  className="w-5/6 py-2 mt-2 font-semibold text-center bg-white border border-transparent rounded"
                >
                  Pagar agora
                </button>
              </div>
            )}
          </div>
        }
      />
    </>
  )
}
